<template>
  <div class="number-input-with-controls flex no-wrap items-center">
    <q-btn
      round
      text-color="black"
      :disable="modelValue <= minValue"
      unelevated
      @click="$emit('update:modelValue', modelValue - 1)"
    >
      <q-icon
        size="16px"
        name="remove"
        class="q-ma-8"
      />
    </q-btn>
    <NumberInput
      class="q-mx-8"
      :model-value="modelValue"
      input-class="text-center"
      :rules="rules"
      borderless
      hide-bottom-space
      no-error-icon
      @blur="insureMinValue"
      @update:modelValue="$emit('update:modelValue', +$event)"
    />
    <q-btn
      round
      text-color="black"
      :disable="modelValue >= 999"
      unelevated
      @click="$emit('update:modelValue', modelValue + 1)"
    >
      <q-icon
        size="16px"
        name="add"
        class="q-ma-8"
      />
    </q-btn>
  </div>
</template>

<script setup>
import { onBeforeUnmount } from 'vue';

import NumberInput from '~components/NumberInput';

const props = defineProps({
  modelValue: {
    type: Number,
    default: null,
  },
  minValue: {
    type: Number,
    default: 0,
  },
  rules: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

function insureMinValue() {
  emit('update:modelValue', props.modelValue || props.minValue);
}

onBeforeUnmount(() => {
  insureMinValue();
});
</script>

<style lang="scss">
.q-field--error .number-input-with-controls input {
  border: 2px solid #f8381e !important;
}

.number-input-with-controls {
  .q-btn {
    background: #e5e5e5;
    min-width: 32px !important;
    min-height: 32px !important;

    &.disabled {
      background: $grey-11 !important;
      border-color: $grey-11 !important;
      color: #9f9f9f;
    }
  }

  .q-field {
    width: 48px;

    .q-field__control {
      height: 40px;
      min-height: 40px;
      padding: 0;

      &::after, &::before {
        content: none;
      }
    }

    input {
      border: 1px solid #e5e5e5;
      height: 40px;
      min-height: 40px;
      border-radius: 8px;
      transition: all 0.36s ease-out;

      &:focus {
        border: 2px solid #000;
      }
    }
  }
}
</style>
